import axios from 'axios';

const getGlobalSettings = () => {
  let url = process.env.PUBLIC_URL + '/settings/global.settings.json';
  return axios.get(url);
};

export default getGlobalSettings;
